import React, { useEffect } from "react";

const SCRIPT_SRC = "https://www-cdn.icef.com/scripts/iasbadgeid.js";

// ICEF's script looks up #iasBadge once, at the moment it runs, then fills it
// in from their API. A tag in index.html would execute before React has
// rendered the footer and find nothing, and every route change hands the badge
// a fresh, empty span -- so the script is loaded here on mount instead.
const IcefBadge = ({ accountId }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);
    return () => script.remove();
  }, []);

  return (
    <span
      id="iasBadge"
      className="icef-badge"
      data-account-id={accountId}
      aria-label="ICEF Agency Status accreditation"
    />
  );
};

export default IcefBadge;
